// extracted by mini-css-extract-plugin
var _1 = "as7YNLb3KK6SIS9SKL7P";
var _2 = "Om6cRclXsGbqEO_H8bAh";
var _3 = "EE1PImU7t8MkcuIQ4mdX";
export { _1 as "header", _2 as "lastNotification", _3 as "messageContainer" }
